<template>
    <CustomModal
        :is-modal-visible="addNewVisible"
        :modal-title="`Thêm mới cấu hình năm học ${selectedYearFromStore} - ${
            selectedYearFromStore + 1
        }`"
        :close-function="handleCloseModalAddNew"
        :size="'md'"
        :err-modal="errModal"
    >
        <template v-slot:content>
            <div class="row">
                <div class="col-md-3">
                    <label class="label">
                        Thời gian <span class="error-label">*</span>
                    </label>
                    <div>
                        <el-date-picker
                            v-model="dateRange"
                            type="daterange"
                            start-placeholder="Từ ngày"
                            end-placeholder="Đến ngày"
                            size="medium"
                            format="dd/MM/yyyy"
                            @change="onChangeDateRange"
                        >
                        </el-date-picker>
                        <span
                            v-if="err_startDate || err_endDate"
                            class="text-error-select"
                        >
                            {{ err_startDate || err_endDate }}
                        </span>
                    </div>
                </div>
            </div>
        </template>

        <template v-slot:btn-handle>
            <CustomButton label="Lưu" @click="handleAddNew" />
        </template>
    </CustomModal>
</template>

<script>
import CustomButton from '@/components/CustomButton.vue'
import { getFromSessionStorage } from '@/utils/session'

import sendRequest from '@/services'
import Api from '@/constants/Api'
import CustomModal from '@/components/CustomModal.vue'
import { showNotication } from '@/utils/notification'
import { formatDateToDDMMYYYY } from '@/utils'
import { validateFields, handlerError } from '@/utils/validator'
export default {
    name: 'ModalAdd',
    data() {
        return {
            dateRange: '',
            startDate: '',
            endDate: '',

            err_startDate: '',
            err_endDate: '',

            errModal: false
        }
    },
    props: {
        addNewVisible: {
            type: Boolean,
            required: true
        },
        closeModalAddNew: Function,
        handleSearch: Function
    },
    components: { CustomButton, CustomModal },
    methods: {
        onChangeDateRange(value) {
            if (value && value.length === 2) {
                this.startDate = value[0]
                this.endDate = value[1]
                this.onChangeHandler('startDate', this.startDate)
                this.onChangeHandler('endDate', this.endDate)
            } else {
                this.startDate = ''
                this.endDate = ''
                this.err_startDate = ''
                this.err_endDate = ''
                this.errModal = false
            }
        },
        onChangeHandler(source, newValue) {
            const errorFields = {
                startDate: 'err_startDate',
                endDate: 'err_endDate'
            }

            handlerError(this, source, newValue, errorFields)

            if (source in errorFields) {
                handlerError(this, source, newValue, errorFields)

                this.errModal = !!newValue || !!this[errorFields[source]]
            } else {
                this.errModal = !!newValue
            }
        },
        handleClearData() {
            this.errModal = false
            this.dateRange = ''
            this.startDate = ''
            this.endDate = ''

            this.err_startDate = ''
            this.err_endDate = ''
        },
        handleCloseModalAddNew() {
            this.closeModalAddNew()
            this.handleClearData()
        },
        async handleAddNew() {
            const fieldsToValidate = [
                {
                    value: this.startDate,
                    errorField: 'err_startDate'
                },
                {
                    value: this.endDate,
                    errorField: 'err_endDate'
                }
            ]

            if (validateFields(this, fieldsToValidate)) {
                const convertStartDate = formatDateToDDMMYYYY(this.startDate)

                const convertEndDate = formatDateToDDMMYYYY(this.endDate)
                const request_data = {
                    dauNamTuNgay: convertStartDate,
                    dauNamToiNgay: convertEndDate,
                    namHoc: this.selectedYearFromStore
                }
                try {
                    const response = await sendRequest(
                        Api.tiep_nhan_du_lieu_QLNT.cau_hinh_lich_dong_bo
                            .them_moi_ngay,
                        request_data,
                        this.request_headers
                    )
                    if (response.rc == 0) {
                        showNotication(this, 'success', 'Thêm mới thành công', {
                            customClass: 'notification-unlock'
                        })
                        this.handleCloseModalAddNew()
                        this.$emit('handleSearch')
                    } else {
                        showNotication(this, 'warning', 'Thêm mới không thành công', {
                            customClass: 'notification-lock'
                        })
                    }
                } catch (error) {
                    if (error.response?.data.rd) {
                        showNotication(this, 'error', error.response?.data.rd)
                    }
                }
            }
        }
    },
    mounted() {},
    computed: {
        selectedYearFromStore() {
            return this.$store.state.selectedYear.selectedYear
        },

        auth_user() {
            return getFromSessionStorage('auth_user')
        },
        request_headers() {
            return {
                token: this.auth_user.token
            }
        }
    }
}
</script>

<style scoped>
.error {
    color: red;
    font-style: italic;
}

.label {
    font-weight: 600;
}
::v-deep .is-error .el-input__inner {
    border: 1px solid #f56c6c !important;
}
::v-deep .is-error .el-input__inner:focus {
    border: 1px solid #f56c6c !important;
    box-shadow: 0 0 3px #f56c6c;
}
</style>
